'use client';

import isPropValid from '@emotion/is-prop-valid';
import { alpha, styled } from '@mui/material/styles';

import { cssStyles } from '../..';

import type { Theme } from '@mui/material/styles';

export const BackgroundImage = styled( 'div', {
  shouldForwardProp: (prop: string) => isPropValid( prop ) && prop !== 'url',
} )(({ theme, url }: { theme: Theme; url: string }) => ({
  padding: theme.spacing( 10, 0 ),
  ...cssStyles( theme ).bgImage( {
    direction: 'right',
    url,
    startColor: `${alpha( theme.palette.grey[900], 0 )} 0%`,
    endColor: `${alpha( theme.palette.grey[900], 0.85 )} 50%`,
  } ),
  [theme.breakpoints.up( 'md' )]: {
    padding: theme.spacing( 15, 0 ),
    ...cssStyles( theme ).bgImage( {
      direction: 'bottom',
      url,
      startColor: `${alpha( theme.palette.grey[900], 0 )} 0%`,
      endColor: `${alpha( theme.palette.grey[900], 0.85 )} 50%`,
    } ),
  },
  [theme.breakpoints.down( 'sm' )]: {
    ...cssStyles( theme ).bgImage( {
      direction: 'bottom',
      url,
      startColor: `${alpha( theme.palette.grey[900], 0 )} 0%`,
      endColor: `${alpha( theme.palette.grey[900], 0.85 )} 30%`,
    } ),
  },
}));
